<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      title="Danh sách cuộc trò chuyện"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="conversations"
        :loading="loading"
        disable-pagination
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:[`item.user.avatar`]="{ item }">
          <v-avatar size="36" class="elevation-2">
            <img
              alt="Avatar"
              :src="item.user.avatar || require('@/assets/face.jpg')"
            />
          </v-avatar>
        </template>
        <template v-slot:[`item.latestMessage.createdAt`]="{ item }">
          {{ formatDate(item.latestMessage.createdAt) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="primary"
            x-small
            :href="`/admin/conversations/${item._id}`"
          >
            Chi tiết
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import ConversationApi from "@/api/ConversationApi";
export default {
  data() {
    return {
      headers: [
        {
          text: "Avatar",
          align: "start",
          sortable: false,
          value: "user.avatar"
        },
        { text: "Tên", value: "user.name" },
        { text: "Email", value: "user.email" },
        { text: "Tin nhắn gần nhất", value: "latestMessage.text" },
        { text: "Thời gian", value: "latestMessage.createdAt" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      conversations: [],
      loading: true,
      loadingUpdate: false,
      userId: this.$route.params.id
    };
  },
  watch: {
    $route(to, from) {
      this.userId = to.params.id;
      this.loadData();
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await ConversationApi.getConversations(this.userId);
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.conversations = data;
      }
    },

    formatDate(date) {
      const createdAt = new Date(date);
      return `${createdAt.toLocaleTimeString()} ${createdAt.toLocaleDateString()}`;
    }
  }
};
</script>
